module.exports = {


	computed:{	

		/*--------------------------
			Locale
		----------------------------*/

		locale(){
	      return this.$t('countryCode')
	    },

		/*--------------------------
			Completed steps
		----------------------------*/

		steps(){

		  var self = this;

		  // Create steps variable 
	      var steps = {
	        background: false,
	        pictureWall: false,
	        motifs: false,
	        frames: false,
	        complete: true
	      }

	      // Check background
	      if(self.$store.state.background)
	        steps.background = true

	      // Check picturewall
	      if(self.$store.state.pictureWall)
	        steps.pictureWall = true

	      // Check motifs
	      var motifsDone = false
	      var motifs = self.$store.state.chosenArticles;

	      if(!$.isEmptyObject(motifs)){
	          var motifsDone = true

	          $.each(self.$store.state.chosenArticles, function(index, value){
	            if(!value){
	              motifsDone = false
	            }
	          })
	      }
	    
	      steps.motifs = motifsDone

	      // Check frames
	      var frames = self.$store.state.chosenFrames;
	      var framesDone = false;

	      if(!$.isEmptyObject(frames)){
	        var framesDone = true
	        $.each(frames, function(index, value){
	          if(!value)
	            framesDone = false
	        })
	      }
	      steps.frames = framesDone

	      $.each(steps, function(index, value){
	          if(!value)
	            steps.complete = false
	      })

	      return steps;

		},

		/*--------------------------
			Current picker
		----------------------------*/

		currentPicker(){
			return this.$store.state.currentPicker;
		},

		currentLeftTitle(){
			return this.$store.state.leftTitle;
		},

		/*--------------------------
			Device
		----------------------------*/

		device(){

			var screen_width = $(window).width()

			return {
				screen_width: screen_width,
				isTouch: (('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0)),
				isMobile: screen_width <= 812,
				isDesktop: screen_width >= 1025,
				tabletUP: screen_width >= 813
			}

		},


	},

	methods: {


	

		/*---------------------------------------
			Owner of this picture wall
		----------------------------------------*/

		checkOwner(){
			var self = this;
			var found = false;
		},

		/*---------------------------------------
			Check if articles exists
		----------------------------------------*/

		ifArticlesExists() {
			
			var exists = false
			var articles = this.$store.state.chosenArticles

			if(!$.isEmptyObject(articles)){

				$.each(articles, function(index, value){
					if(value !== false)
						exists = true
				})
			}

			return exists;
			
		},

		/*---------------------------------------
			Check if article has campaign
		----------------------------------------*/

		articleHasCampaign(product) {
			
			if(typeof product.campaignBadge != 'undefined' && product.campaignBadge)
				return true

			return false
			
		},

		/*---------------------------------------
			Decide width
		----------------------------------------*/

		pictureWallWidth(){

			var width = this.device.screen_width

			if(width > 1400)
				return false;
			else if(width <= 1399 && width > 1200){
				return 1400
			}
			else if(width <= 1200 && width > 900){
				return 1300
			}
			else if(width <= 900){
				return 1201
			}
		}

	}
	
};


// WEBPACK FOOTER //
// ./client/mixins/checks.js